import Repository from "./repository.js";
import Path from "./apiPath";
// import termsInfomation from "../../../jsons-data/mocks/termsInformation.json";
// import axios from '@/axios'

export default {
  getTermsInformation() {
    // return new Promise((resolve, reject) => {
    //   axios.get('/v1/agreeterms/terms_information').then(
    //     () => {
    //       resolve(termsInfomation)
    //     }
    //   )
    // })
    return Repository.get(Path.getTermsInformation);
  },
  getAgreeRegister() {
    return Repository.get(Path.getAgreeRegister);
  },
  /**
   * 規約同意有無確認
   */
  getAgreeCheck() {
    // return new Promise((resolve, reject) => {
    //   axios.get('/v1/agreeterms/check').then(
    //     () => {
    //       resolve({ "consentStatusFlg": true })
    //     }
    //   )
    // })
    return Repository.get(Path.getAgreeCheck);
  }
};
